import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CompanySetupService } from '../../shared/services/company-setup.service';
import { WebServiceService } from '../../shared/services/web-service.service';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';

@Component({
  selector: 'app-allocable-cost-table',
  templateUrl: './allocable-cost-table.component.html',
  styleUrls: ['./allocable-cost-table.component.scss'],
  providers: [CompanySetupService, WebServiceService]
})
export class AllocableCostTableComponent implements OnInit, OnChanges {
  @Input() allocableCostDetails: any = {};
  
  company_setup: any = {};
  setup: any = {};
  lines: any[] = [];
  viewContext: any = {};
  caption: string = 'Additional Cost Line items (Not Part of Vendor PO)';
  diffCurrencyKey: string = 'is_different_document_currency';
  documentCurrencyCodeKey: string = 'document_currency_code';
  treatDiffCurrencyFlagAsBoolOrOneZero: boolean = true;
  companyThemeBlockColor: string = '#035168';
  CompanyThemetextColor: string = '#FFFFFF';

  constructor(
    public comanySetup: CompanySetupService,
    public webService: WebServiceService,
    public _localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    this.bindAllocableCostInput();
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
    this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.allocableCostDetails) {
      this.bindAllocableCostInput();
    }
  }

  private bindAllocableCostInput(): void {
    if (this.allocableCostDetails && this.allocableCostDetails.id) {
      this.setup = this.allocableCostDetails.setup ? this.allocableCostDetails.setup : {};
      this.setup.is_setup = this.allocableCostDetails.is_setup ? this.allocableCostDetails.is_setup : false;

      // Get lines from allocableCostDetails
      this.lines = this.allocableCostDetails.lines || this.allocableCostDetails.allocable_cost_items || [];
      
      // Get viewContext from allocableCostDetails
      this.viewContext = this.allocableCostDetails.viewContext || this.allocableCostDetails.data || this.allocableCostDetails || {};
      
      // Get caption if provided
      this.caption = this.allocableCostDetails.caption || this.caption;

      if (this.setup.is_setup) {
        this.setSetupData(this.setup);
      } else {
        this.GetCompanySetUpData();
      }
    } else {
      this.lines = [];
    }
  }

  GetCompanySetUpData() {
    let req = {};
    this.company_setup = {};
    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
      (data: any) => {
        if (data.status) {
          this.company_setup = data.response ? data.response : {};
          this.company_setup.comma_separate_currency_code = this.company_setup.comma_separate_currency_code ? this.company_setup.comma_separate_currency_code : 'IND';
          this.company_setup.is_enable_comma_separate_price = this.company_setup.is_enable_comma_separate_price ? this.company_setup.is_enable_comma_separate_price : '0';
          this.setSetupData(this.company_setup);
        }
      },
      (error) => {
        // Handle error silently or show message if needed
      }
    );
  }

  setSetupData(setupData: any) {
    this.company_setup = setupData;
  }

  get hasDifferentDocumentCurrency(): boolean {
    const ctx = this.viewContext || {};
    const raw = ctx[this.diffCurrencyKey];

    if (!this.treatDiffCurrencyFlagAsBoolOrOneZero) {
      return !!raw;
    }

    if (typeof raw === 'string') {
      return raw === '1' || raw.toLowerCase() === 'true';
    }
    return !!raw;
  }

  get documentCurrencyCode(): string {
    const ctx = this.viewContext || {};
    return ctx[this.documentCurrencyCodeKey] || this.company_setup.currency_icon || '';
  }

  get baseCurrencyIcon(): string {
    return this.company_setup.currency_icon || '';
  }

  /**
   * Sum helper for totals row.
   * @param type 'po_currency' | 'base_currency'
   */
  getTotal(type: 'po_currency' | 'base_currency'): number {
    if (!this.lines || this.lines.length === 0) {
      return 0;
    }
    const key =
      type === 'po_currency'
        ? 'planned_amount_in_po_currency'
        : 'planned_amount_in_base_currency';

    return this.lines.reduce((sum, line) => {
      const val = parseFloat(line && line[key] != null ? line[key] : 0);
      return sum + (isNaN(val) ? 0 : val);
    }, 0);
  }
}








// WEBPACK FOOTER //
// /codebuild/output/src1351935441/src/src/app/generic-ui-components/allocable-cost-table/allocable-cost-table.component.ts